<ds-collection-search-result-list-element [object]="object"
                                          [index]="index"
                                          [linkType]="linkType"
                                          [listID]="listID"></ds-collection-search-result-list-element>
<div>
    <a class="btn btn-light mt-1" data-test="coll-link" [routerLink]="[editPath]">
        <i class="fa fa-edit"></i> {{"admin.search.collection.edit" | translate}}
    </a>
</div>
